import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';

import {withError} from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import {colors, fontSizes, fonts, layout, shadow} from 'style';
import defaultAvatar from 'img/default-avatar.png';

var style = {
    content: {
        position:'relative',
        ...fonts.body,
        lineHeight: '1.5',
    },
    body: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
    },
    recordBarContainer: {
        position: 'relative',
        marginTop: '0',
        marginBottom: '0',

        height: '80px',
    },
    rank: {
        display: 'inline-block',
        height: '100%',
        fontSize: '1.5em',
        width: '60px',
        verticalAlign: 'middle',
        textAlign: 'center',
        position: 'relative',
        top: '3px',
        lineHeight: '75px',
        color: colors.themeLightBlue,
    },
    avatarContainer: {
        display: 'inline-block',
        height: '100%',
        fontSize: '1.5em',
        width: '180px',
        verticalAlign: 'middle',
        textAlign: 'left',
        position: 'relative',
        top: '-1px',
        lineHeight: '75px',
    },
    avatarWrapper: {
        display: 'inline-block',
        borderRadius: '50%',
        height: '48px',
        width: '34px',
        verticalAlign: 'middle',
    },
    avatar: {
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '48px',
        width: '48px',
        verticalAlign: 'top',
    },
    recordBarBody: {
        position: 'absolute',
        paddingLeft: '120px',
        paddingRight: '115px',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
    },
    personInfo: {
        marginTop: '20px',
        width: '100%',
        textOverflow: 'ellipsis'
    },
    personalInfoItem: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        color: colors.themeDarkerGrey,
    },
    recordPoints: {
        height: '100%',
        width: '100px',
        color: colors.pointsYellow,
        float: 'right',
        fontSize: '1.1em',
        fontWeight: 'normal',
        paddingTop: '38px',
        textAlign: 'left',
    },
    icon: {
        position: 'relative',
        top: '2px',
        left:'-5px',
    },
    progressBar: {
        marginTop: '5px',
        height: '10px',
        width: '100%',
        backgroundColor: colors.themeBlue,
        background: 'linear-gradient(to right, '+colors.themeBlue+', '+colors.themeTeal+')',
        borderRadius: '4px',
    },


    recordBar: {
        position: 'relative',
        padding: '8px',
        height: '64px',
        backgroundColor: '#F0F0FF',
        borderTopRightRadius: '32px',
        borderBottomRightRadius: '32px'
    },
    textContainer: {
        display: 'table',
        tableLayout: 'fixed',
        width:'100%', 
        height:'100%', 
        paddingRight:'64px', 
    },
    textClipper: {
        verticalAlign: 'middle',
        display: 'table-row',
        width:'100%',
        height: '100%',
        minWidth: '100px'
    },
    myRow: {
        backgroundColor: colors.themeTeal,
        borderRadius: '6px',
    },
    myPoints: {
        color: '#fff',
    },
    myRank: {
        color: '#fff',
    },
    myProgressBar: {
        backgroundColor: '#fff',
        background: '#fff',
    },
    myInfo: {
        color: '#fff',
    },
    clickable: {
        cursor: 'pointer',
    },
    teamBanner: {
        boxShadow: shadow,
        paddingTop: '15px',
        height: '200px',
        backgroundColor: colors.themeBlue,
        textAlign: 'center',
    },
    teamAvatar: {
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '50%',
        height: '100px',
        width: '100px',
        verticalAlign: 'top',
        WebkitFilter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.25))',
        msFilter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=2, Color='#AAA')",
        filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.25))',
    },
    teamRank: {
        color: '#fff',
        fontSize: '1.2em',
        padding: '10px 0px 5px 0px',
    },
    teamPointsContainer: {
        width: '100%', 
        height:'32px'
    },
    teamPoints: {
        textAlign: 'right',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        fontWeight: 'normal',
        position: 'relative',
        minWidth: '100px',
        paddingLeft: '40px',
        paddingRight: '20px',
        borderRadius: '100px',
    },
    starIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.5em',
        opacity: '1',
        color: '#FFF'
    },
    teamBannerMessage: {
        textAlign: 'center',
        color: colors.themeBlue,
        paddingTop: '10px',
        backgroundColor: 'white',
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    loader: {
        marginTop: '10px',
    },

};

const ranks = {
    1:{color: colors.pointsYellow},
    2:{color: '#C0C0C0'},
    3:{color: '#CD7F32'},
}
const avatars = {
    1:{borderColor: colors.pointsYellow},
    2:{borderColor: '#C0C0C0'},
    3:{borderColor: '#CD7F32'},
}

const Leaderboard = ({t,
                      records, 
                      leaderboard, 
                      targetPoints, 
                      onClickLeaderboard, 
                      column, 
                      busy, 
                      onClickRecord,
                      onScroll,
                      setScrollContainer,
                      isMember,
                      isClickable,
                      getName,
                      getAvatars,
                      formatLeaderboardValue}) => (
    <div className="full-height scrollable" onScroll={onScroll} ref={(el)=>(setScrollContainer(el))} style={style.content}>
        {Boolean(leaderboard && leaderboard.teamInfo) &&
            <div>
                <div style={style.teamBanner}>
                    <div style={{...style.teamAvatar, backgroundImage:Utils.url(Boolean(leaderboard.teamInfo.avatar && leaderboard.teamInfo.avatar.url) ? leaderboard.teamInfo.avatar.url : defaultAvatar)}} />
                    <div style={style.teamRank}>{t('Rank_{{no}}', {no:leaderboard.teamInfo.rank})}</div>
                    <div style={style.teamPointsContainer}><Label style={style.teamPoints} size='large' color='yellow'><span style={{width:'20px'}}><Icon style={style.starIcon} className="notClickable icon-star"/></span><span className="bold"> </span><span className="right floated">{leaderboard.teamInfo.points}</span></Label></div>
                </div>
                <div style={style.teamBannerMessage}>{t('Team Leaders')}</div>
            </div>
        }
        <div style={style.body}>
            {records && leaderboard && records.map((record) => (
                <div key={record.id} style={{...style.recordBarContainer, ...(isMember(record) ? style.myRow : {}), ...(isClickable(record) ? style.clickable : {})}} onClick={()=>onClickRecord(record)} >
                    <div style={{...style.rank, ...(ranks[record.rank]), ...(isMember(record) ? style.myRank : {})}}>
                        {record.rank}
                    </div>
                    <div style={style.avatarContainer}>
                        {getAvatars(record[leaderboard.scope]).map((url,avatarIndex)=>(
                            <div key={avatarIndex} style={style.avatarWrapper}><div style={{...style.avatar, ...(avatars[record.rank]), backgroundImage:Utils.url(url ? url : defaultAvatar)}} /></div>
                        ))}
                    </div>

                    <div style={{...style.recordBarBody, paddingLeft:(String(80+34*getAvatars(record[leaderboard.scope]).length)+'px')}}>
                        <div style={style.personInfo}>
                            <div style={{...style.personalInfoItem, ...(isMember(record) ? style.myInfo : {})}}>{getName(record[leaderboard.scope])}</div>
                        </div>
                        <div style={{...style.progressBar, ...(isMember(record) ? style.myProgressBar : {}), width:(String(Utils.getPercent(record[column], targetPoints))+'%')}} />
                    </div>

                    <div style={{...style.recordPoints, ...(isMember(record) ? style.myPoints : {})}}>
                        <i style={style.icon} className={leaderboard.icon} /> 
                        {formatLeaderboardValue(record, column)}
                    </div>
                </div>
                ))
            }
            {busy && 
                <LoadInline centered style={style.loader} /> 
            }
        </div>
    </div>
);


export default translate('leaderboards')(withError(Leaderboard));



// WEBPACK FOOTER //
// ./src/modules/leaderboards/Leaderboard.js